import { clueTimeline, contradictions } from '@/mocks/chigua';
import { SectionHead } from './HotDeep';
import { iconMap } from './icons';

export function ClueTimeline() {
  return (
    <section id="clue" className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <SectionHead
        eyebrow="Evidence"
        title="一张热瓜是怎么被扒出来的"
        desc="以近期榜首事件为例，我们按分钟还原一条线索从出现、放大、对比到发酵的完整路径。"
      />
      <div className="relative mt-10">
        <div className="absolute bottom-4 left-[19px] top-4 w-0.5 bg-background-200 md:left-1/2 md:-translate-x-1/2"></div>
        <ol className="space-y-8">
          {clueTimeline.map((c, i) => {
            const right = i % 2 === 1;
            return (
              <li key={c.stage} className="relative flex gap-6 md:gap-0">
                <div className="relative z-10 grid h-10 w-10 shrink-0 place-items-center rounded-full border border-background-300 bg-background-50 text-primary-600 md:hidden">
                  <i className={iconMap[c.icon]}></i>
                </div>
                <div
                  className={`flex w-full flex-col md:w-1/2 ${right ? 'md:pl-12' : 'md:pr-12 md:items-end md:text-right'}`}
                >
                  <div className="rounded-xl border border-background-200 bg-background-100 p-5">
                    <div className="flex items-center gap-2">
                      <span className="font-heading text-2xl font-black text-primary-500">{c.time}</span>
                      <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-semibold text-accent-700">
                        {c.stage}
                      </span>
                    </div>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-700">{c.text}</p>
                    <div className="mt-4">
                      <div className="mb-1 flex items-center justify-between text-xs text-foreground-500">
                        <span>讨论热度</span>
                        <span className="font-semibold text-primary-600">{c.heat}</span>
                      </div>
                      <div className="h-1.5 overflow-hidden rounded-full bg-background-200">
                        <div
                          className="h-full rounded-full bg-gradient-to-r from-primary-500 to-primary-300"
                          style={{ width: `${c.heat}%` }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="relative z-10 hidden w-1/2 shrink-0 md:block">
                  {!right && <div className="md:pl-12"></div>}
                </div>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}

export function Contradictions() {
  return (
    <section className="bg-accent-950">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <div className="flex flex-col justify-between gap-4 md:flex-row md:items-end">
          <div>
            <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-accent-300">
              <span className="h-px w-6 bg-accent-400"></span>
              Red Flags
            </p>
            <h2 className="mt-2 font-heading text-2xl font-black tracking-tight text-background-50 md:text-4xl">
              老瓜农常盯的几处破绽
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-accent-200 md:text-base">
              这些是深挖时最常出现的矛盾类型，先认识它们，再谈判断真假。
            </p>
          </div>
          <a
            href="#guide"
            className="inline-flex w-fit cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-accent-400/60 px-5 py-2.5 text-sm font-semibold text-accent-100 transition-colors hover:bg-accent-500 hover:text-accent-950"
          >
            学全套方法论 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {contradictions.map((c) => (
            <article key={c.title} className="rounded-xl border border-accent-800 bg-accent-900/40 p-5">
              <span className="inline-flex rounded-full bg-accent-500 px-2.5 py-0.5 text-xs font-bold text-accent-950">
                {c.level}
              </span>
              <h3 className="mt-3 font-heading text-lg font-bold text-background-50">{c.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-accent-200">{c.point}</p>
              <p className="mt-4 flex items-start gap-2 rounded-md bg-accent-950/60 p-3 text-xs leading-relaxed text-accent-100">
                <i className="ri-lightbulb-flash-line mt-0.5 shrink-0 text-accent-300"></i>
                <span>{c.clue}</span>
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}